import React, { useEffect, useReducer, useState } from 'react';
import { Empty, Row, Col, Select, Typography, Button, Space, Table, Modal, DatePicker, Tooltip, message, Spin, Popover, Avatar, Card, Tag, Tabs, Form } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import { SHIFT_REPORT_LIST, SHIFT_REPORT_ERROR, SHIFT_REPORT_SUCCESS, SHIFT_LIST_DETAILS, SHIFT_LIST_DETAILS_ERROR, SHIFT_LIST_DETAILS_SUCCESS, SHIFT_QUESTIONS_SUCCESS, SHIFT_QUESTIONS_ERROR, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR } from './constants';
import axios from 'axios';
import shiftdata from './reducer';
import {BatchDownloader} from './downloader';
import { DownloadOutlined, ScheduleOutlined , InfoOutlined, SnippetsOutlined, FilePdfOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import moment from 'moment';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { datetimeCovertertolocal } from '../../datetime-converter';
import TabPane from 'antd/es/tabs/TabPane';
import { BatchQADownloader } from './shiftQAdownloader';



// const { Paragraph } = Typography;


const { Title } = Typography;
const { RangePicker } = DatePicker;

let shift_data_pagination = {};

export default function ShiftReport() {
	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const navigate = useNavigate();
	const {getRegion, regiondata, getUserAllocation ,getUserAllocationData} = useAuth();
	const initalState = {shift_data:[],  details: null, questions:null, pending: false, error: false };
	const [shift_data, dispatch] = useReducer(shiftdata, initalState);
	const [regionId, setRegionId] = useState(null);
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);
	const [url, setURL] = useState(null);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [allocationId, setAllocationId] = useState(null);
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const [openAttachmentModal, setShowAttachmentsModal] = useState(false);
	
	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	

	const [openQuestionModal, setShowQuestionModal] = useState(false);
	const [QAurl,setQAURL] = useState();
	const [QADownloadModal,setShowQADownloadModal] = useState(false);
	const [user, setUser] = useState(null);
	



	let Shiftdata = [];
	shift_data.shift_data && shift_data.shift_data.map((item) => {

		const shift_date_time = datetimeCovertertolocal(item ? item.shiftDateTime : '<Not Set>');
		const new_shift_date_time = item && item.shiftDateTime ? (shift_date_time.localdate + ' ' + shift_date_time.localtime) : '<Not Set>';

		const start_date_time = datetimeCovertertolocal(item ? item.startDateTime : '<Not Set>');
		const new_start_date_time = item && item.startDateTime ? (start_date_time.localdate + ' ' + start_date_time.localtime) : '<Not Set';

		Shiftdata.push({	
			key: item.id,
			id: item.id,
			allocationId : item.allocationId,
			outgoingUser : item.outgoingusers.firstName + ' ' +  item.outgoingusers.lastName,
			incomingUser : item.incomingusers.firstName + ' ' + item.incomingusers.lastName,
			name : item.name,
			startDateTime : new_start_date_time,
			shiftDateTime : new_shift_date_time,
			remarks : item.remarks,
			status : item.status,
			pipelineChainage : item.pipelineChainage,
			attachmentUrls : item.attachmentUrls,
			pipelineId : item.pipelineId,
			createdAt : item.createdAt,
			updatedAt : item.updatedAt
		});
		
	});

	let image_attachements = [];
	let video_attachements =[];
	let audio_attachements =[];

	shift_data?.details?.attachmentUrls? shift_data.details.attachmentUrls.map((item)=>{

		const lower = item.toLowerCase().trim();
		if (lower.endsWith('.jpeg') || lower.endsWith('.jpg') || lower.endsWith('.png') || lower.endsWith('.svg') || lower.endsWith(' ')) {
			image_attachements.push(item);
		} else if (lower.endsWith('.mp3') || lower.endsWith('.wav') || lower.endsWith('.aac')|| lower.endsWith('.mpga')) {
			audio_attachements.push(item);
		} else if (lower.endsWith('.mp4') || lower.endsWith('.mov') || lower.endsWith('.avi') || lower.endsWith('.3gp') || lower.endsWith('.mkv') || lower.endsWith('.flv')) {
			video_attachements.push(item);
		}

	}):null;

	

	const columns = [
		{
			title: `${langdata&&langdata.Allocations?langdata.Allocations:'Allocations'}`,
			dataIndex: 'name',
			key: 'name',

		},
		{
			title: `${langdata&&langdata.ShiftDate ? langdata.ShiftDate : 'Shift Date'}`,
			dataIndex: 'shiftDateTime',
			key: 'shiftDateTime',
		},
		{
			title: `${langdata&&langdata.OutgoingUser ? langdata.OutgoingUser : 'Outgoing User'}`,
			dataIndex: 'outgoingUser',
			key: 'outgoingUser',
		},
		{
			title: `${langdata&&langdata.IncomingUser ? langdata.IncomingUser : 'Incoming User'}`,
			dataIndex: 'incomingUser',
			key: 'incomingUser',
		},
		{
			title: `${langdata&&langdata.Remark ? langdata.Remark:'Remark'}`,
			dataIndex: 'remarks',
			key: 'remarks',
		},
		{
			title: `${langdata&&langdata.Location ? langdata.Location:'Location'}`,
			dataIndex: 'pipelineChainage',
			key: 'pipelineChainage',
		},
		{
			title: `${langdata&&langdata.Status ? langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',

			render: (_, { status }) => (
				<>
					<Tag color={status === 'Change' ?'yellow' :'green'} >
						{status === 'Change' ? langdata && langdata.Change ? langdata.Change : 'Change' : langdata && langdata.Completed ? langdata.Completed : 'Completed'}
					</Tag>
				</>
			),
		},

      
		{
			title: `${langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}`,
			key: 'Attachments',
			align:'center',
			render: (_,record) => (
				<Space style={{justifyContent:'center',display:'flex'}} size="middle">
					<a title={langdata && langdata.SHOWATTACHMENTS ? langdata.SHOWATTACHMENTS:'SHOW ATTACHMENTS'} disabled={record.attachmentUrls.length <=0} onClick={record.attachmentUrls.length > 0 ? openShowAttachments : null}><SnippetsOutlined/></a>
					<a title={langdata && langdata.SHOWREPORTS ? langdata.SHOWREPORTS:'SHOW REPORTS'}  onClick={()=>handleShiftQuestions(record)}><FilePdfOutlined /></a>
				</Space>
			)
		},
		
	];

	let regions=[{value:null,
		label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}`
	}];

	if(admin_roles.includes(permission)){ 	
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		});
	} else {
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			});
		});
	}


	useEffect(() => {
		if(featuresModule.reportShiftEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4008);
	}, []);
	
	useEffect(()=>{
		if(!authtoken){
			navigate('/');
		}
		else{
			if(admin_roles.includes(permission)){
				getRegion(authtoken);
			}
			else{
				getUserAllocation(authtoken);
			}
			usersList();
			getShift(1);
		}

	},[authtoken,regionId, startDate, endDate, allocationId, user]);

	

	const getShift =(pagination)=>{

		let _pagination = { };
		_pagination.total = shift_data_pagination.total ? shift_data_pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current ? parseInt((pagination.current-1) * pagination.pageSize) : 0;

		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE`, pagination && pagination.current ? pagination.current : 1);
		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE_SIZE`, pagination && pagination.pageSize ? pagination.pageSize : 10);

		let allocationParams = '';
		if(admin_roles.includes(permission)){
			allocationParams = regionId ? `&regioninfoId=${regionId}` : '';
		}
		else{
			allocationParams = allocationId ? `&allocationId=${allocationId}` : '';
		}

		let userParams = '';
		if(user){
			userParams =`&$and[0][userId]=${user}`;
		}
		else{
			userParams = '';
		}
		
		dispatch({ type :SHIFT_REPORT_LIST});
		setURL({base: `${api}/shiftreport-list`,params:`pipelineId=${parseInt(pipelineId)}${allocationParams}&shiftDateTime[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&shiftDateTime[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/shiftreport-list?pipelineId=${parseInt(pipelineId)}${allocationParams}&$sort[id]=-1&shiftDateTime[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&shiftDateTime[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}${userParams}`, 
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					shift_data_pagination.total = response.data.total ? response.data.total : 0;
					shift_data_pagination.limit = response.data.limit ? response.data.limit : 10;
					shift_data_pagination.skip = response.data.skip ? response.data.skip : 0;
					shift_data_pagination.current = pagination.current ? pagination.current : 1;
					dispatch({ type : SHIFT_REPORT_SUCCESS, payload : response.data.data});
				
				}else {
					dispatch({ type : SHIFT_REPORT_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SHIFT_REPORT_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};


	


	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}else{
					
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}
		} else {
			console.log('Clear');
		}
	};


	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};
	


	const handleSetregion = (e, options) =>{
		localStorage.setItem(`${dashboardtype}_REGION_ID`,e);
		if(admin_roles.includes(permission)) {
			setRegionId(e);
		} else {
			setRegionId(options.region);
			setAllocationId(e);
		}
		
	};

	const openShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const closeShowAttachments = () => {
		setShowAttachmentsModal(false);
		
	};

	const openShowAttachments = () => {
		
		setShowAttachmentsModal(true);

	};

	const closeShowQuestionModal = () => {
		setShowQuestionModal(false);
	};

	const openShowQADownloadModal = () => {
		setShowQADownloadModal(true);
	};

	const closeShowQADownloadModal = () => {
		setShowQADownloadModal(false);
	};
	const loadshiftlistdetails = ((record) => {
	
		dispatch( { type: SHIFT_LIST_DETAILS });
		
		if (!record) {
			dispatch({ type: SHIFT_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: SHIFT_LIST_DETAILS_SUCCESS, payload: record });
	
		}
	
	});

	const handleDownload = (imageUrl) => {
		fetch(imageUrl)
			.then(response => response.blob())
			.then(blob => {
				// Extract filename from URL
				const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch(error => console.error('Error downloading image:', error));
	};
	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.ShiftReportInfoContent ? langdata.ShiftReportInfoContent :'This module is used by STS users to record shift change details, including timings and remarks, and to submit information for the next shift users.'}</p>
			<br />
			
		
			
		</Card>
	);
	const handleShiftQuestions = (record) =>{
		loadShiftQuestions(record.id);
		setShowQuestionModal(true);
		loadshiftlistdetails(record);
	};

	const loadShiftQuestions = (Id) => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/shiftanswers?shiftreportId=${Id}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}&$sort[id]=1`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		setQAURL({base: `${api}/shiftanswers?shiftreportId=${Id}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}&$sort[id]=1`});

		axios
			.request(config)
			.then((response) => {

				
				if (response.status === 200) {
					dispatch({type:SHIFT_QUESTIONS_SUCCESS, payload: response.data});
				}
				
			})
			.catch((error) => {
				dispatch({type:SHIFT_QUESTIONS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	let users=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];

	shift_data.users_data && shift_data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const handleSetUser = (e) =>{
		setUser(e);
	};

	const usersList = () => {
	
		dispatch({ type : USERS_LIST});
	
			
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?&isDeleted=false&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	const getDateWithTime = (date, time) => {
		if (!time) return date;

		const [hour, minute, second] = time.split(':').map(Number);

		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};



	return (
		<>
			<Content>
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
				>
					<Col span={10}>
						<Row>

							<Space>
								<ScheduleOutlined style={{fontSize:'30px'}}/>
							</Space>

							<Space>&nbsp;&nbsp;</Space>
					
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ShiftReport?langdata.ShiftReport:'Shift Reports'}</Title>
						</Row>
					</Col>
					<Col style ={{display:'flex',justifyContent:'flex-end'}} span={14} >
						<Row style ={{display:'flex',justifyContent:'flex-end',}}>
							<Col span={24} style={{display:'flex',flexWrap:'wrap',justifyContent:'flex-end', gap:'8px',maxWidth:'920px',paddingRight:'10px'}}>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion:'Filter by region'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '240px', maxWidth:'240px', margin:'5px', display : 'none'}}
											placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion:'Select Region'}
											optionFilterProp="children"
											// value={regionId}
											defaultValue={null}
											options={regions}
											onSelect={(e, options)=>handleSetregion(e, options)}
										/>
									</Space>
								</Tooltip>
								<Space>&nbsp;&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.FilterbyUser ? langdata.FilterbyUser :'Filter by User'}>
																									
									<Space>
										<Select Item
											style={{ minWidth: '145px', marginTop:'5px',marginBottom:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.SelectUsers ? langdata.SelectUsers :'Select Users'}
											optionFilterProp="children"
											// onChange={onChange}
											// onSearch={onSearch}
											// filterOption={filterOption}
											defaultValue={null}
											options={users}
											onSelect={handleSetUser}
																									
										/>  
									</Space>
								</Tooltip>
								{/* <Space>&nbsp;&nbsp;</Space> */}

								<Space>

									<Tooltip title={langdata?.Selectdate || 'Select date'}>
										<RangePicker
											style={{ marginTop:'5px',marginBottom:'5px',maxWidth:'420px'}}
											onChange={onRangeChange}
											disabledDate={disabledDate}
											allowClear={false}
											showTime
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
										/>
									</Tooltip>							
									{/* <Tooltip title={moment(startDate).format(settingsdateformat) + ' - ' + moment(endDate).format(settingsdateformat)} placement='bottom'>
																	
										<RangePicker style={{ width: '220px', margin:'5px'}} onChange={onRangeChange} allowClear={false} format={settingsdateformat}
											value={[dayjs(startDate),dayjs(endDate)]}
											defaultValue={[dayjs(startDate),dayjs(endDate)]}
																					
											// defaultValue={[dayjs(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30)),dayjs(new Date())]}
											disabledDate={disabledDate}
										/>
									</Tooltip> */}
								</Space>
								{/* <Space>&nbsp;&nbsp;</Space> */}
								<Space>
									<Typography>
										<Popover title={'Shift Reports'}  content={infoContent} trigger="click">
											<Avatar size="small" style={{marginTop:'5px',marginBottom:'5px'}}><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
					{/* </Space> */}
				</Row>

				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ Shiftdata.length >0 ? (
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={Shiftdata} pagination = { Shiftdata.length > 0 ? shift_data_pagination : 0 }  onChange = { getShift } 
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadshiftlistdetails(record);
												
										}
									};
								}}/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>

				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					<Col style={{
						alignItems:'left',
						justifyContent:'left',
						display:'flex',
						padding:'10px'
					}}  className="gutter-row" span={24}>
						<Button disabled={Shiftdata && Shiftdata.length > 0 ? false : true} type="primary" title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
					</Col>

				</Row>

			</Content>
            



			{/* Fetch and Download Modal Starts */}
			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={showFetchAndDownloadModal}
				onOk={{closeShowFetchAndDownloadModal}}
				onCancel={closeShowFetchAndDownloadModal}
				footer={[
					
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {shift_data_pagination.total}
						</Typography>
					</Col>
				</Row>

				{shift_data_pagination && shift_data_pagination.total> 0 ? (
					<BatchDownloader total={shift_data_pagination && shift_data_pagination.total} url={url}/>
				) : (
					<>
						<Row gutter={16} style={{
							backgroundColor: '#d3d3d3',
							padding: '5px',
							marginTop: '10px'
						}}>
							<Col span={24}>
								<Typography>{langdata && langdata.Norecordsfound ? langdata.Norecordsfound:'No records found.'}</Typography>
							</Col>
						</Row>
						<br/>
					</>
          
				)}
			</Modal>
			{/* Fetch and Download Modal Modal Ends */}
			<Spin spinning={shift_data.pending} fullscreen />

			{/* Attachment Modal starts */}


				

			<Modal
				title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}
				centered
				destroyOnClose={true}
				open={openAttachmentModal}
				onOk={{closeShowAttachments}}
				onCancel={closeShowAttachments}
				footer={[
				]}
				width={540}>
				<div  style={{ paddingTop: '20px',height:'400px',overflowY:'scroll' }}>

					<>
						<Tabs defaultActiveKey='1' style={{marginBottom:'10px'}}>
							<TabPane tab={langdata && langdata.Image ? langdata.Image : 'Image'} key='1'  >

								{image_attachements && image_attachements.length>0 ?

									image_attachements.map((item,index)=>(

										<div key={index}>
											<img  style={{width:'100%', height:'360px'}} src={item.trim()} alt='image' />

											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'5px',marginBottom:'20px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																


										</div>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}

							</TabPane>

							<TabPane tab={langdata && langdata.Audio ? langdata.Audio : 'Audio'} key='2'>
								
								{audio_attachements && audio_attachements.length>0 ?
								
									audio_attachements.map((item,index)=>(
										<>
											<audio style={{width:'100%'}}  key={index} controls>
												<source src={item.trim()} />
								
								
								
											</audio>
								
								
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																								
								
								
										</>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								
								}
								
							</TabPane>
							<TabPane tab={langdata && langdata.Video ? langdata.Video : 'Video'} key='3'>
								
								{video_attachements && video_attachements.length>0 ?
								
									video_attachements.map((item,index)=>(
										<>
											<video key={index} controls  style={{width:'100%'}}>
												<source src={item.trim()} />
								
											</video>
								
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px', marginBottom:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																								
										</>
																							
									)):
									<Empty  image={Empty.PRESENTED_IMAGE_SIMPLE} />
								
								}
								
							</TabPane>	
						</Tabs>
					</>
				</div>
			</Modal>
			{/* Question Modal starts */}
			<Modal
				title={ langdata&&langdata.ShiftReport?langdata.ShiftReport:'Shift Report' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={openQuestionModal}
				onOk={closeShowQuestionModal}
				onCancel={closeShowQuestionModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							width: '100%',
							
						}}
					>
						{/* Left side buttons */}
						<Space style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							width: '100%',
							
						}}>
							<Button
								disabled={shift_data?.questions?.data.length > 0 ? false : true}
								type="primary"
								title={langdata?.DownloadReport || 'Download Report'}
								onClick={openShowQADownloadModal}
							>
								<DownloadOutlined />
								{langdata?.Download || 'Download'}
							</Button>

							<Button onClick={closeShowQuestionModal}>
								{langdata?.CLOSE || 'CLOSE'}
							</Button>
						</Space>

						{/* Right side (optional future button) */}
						{/* permission === 'admin' && <Button type="primary">SAVE</Button> */}
					</div>
				]}
				width={800}
			>
				<Form layout="vertical" >
					{shift_data?.questions && (
						<><Row gutter={{
							xs: 8,
							sm: 16,
							md: 24,
							lg: 32,
						}}
						>
							<Col span={24}>
								{shift_data?.questions?.data.length > 0 ? shift_data?.questions?.data.map((item) => (
									<Form.Item
										key={item.id}
										label={`Q: ${item.shiftquestions.text}`}

									>
										<Card size="small"  style={{
											
											border: '1px solid #BFBFBF',
										}}>
											{item.text || '-'}
										</Card>
									</Form.Item>
								)):<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}
							</Col>
						</Row></>
					)}
					
				</Form>
			</Modal>

			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={QADownloadModal}
				onOk={{closeShowQADownloadModal}}
				onCancel={closeShowQADownloadModal}
				footer={[
					
														
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{/* {langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {data.pagination.total} */}
						</Typography>
					</Col>
				</Row>
									
				
				<BatchQADownloader  total={shift_data?.questions?.total} url={QAurl} 	users={shift_data?.details}	 />
				
			</Modal>
			
		</>
		
	);
}